import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP, zodTDateISODate } from '~/lib/zod';
import dedent from 'dedent';

export type LetterheadCount = z.infer<typeof countSchema>;

export type LetterheadPaper = z.infer<typeof paperSchema>;

export const countSchema = z.enum([
  '250',
  '500',
  '1000',
]);

export const paperSchema = z.enum(['smooth_white']);

export default createPerformableConfig(
  'letterheads',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      count: countSchema,
      paper: paperSchema,
      need_by: zodTDateISODate('Need By date is required'),
    }),
  },
  {
    name: 'Letterheads',
    group: 'Agent Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/print/letterheads/thumbnail_v2.jpg',
    images: [],
    short: dedent`
      Make every business communication stand out with our professional letterhead \
      printing. Choose between Smooth White or Premium Linen White paper to perfectly \
      match your brand’s style and tone. Our high-quality printing ensures crisp, clear \
      text and vibrant colors, delivering a polished and elegant look that reflects your \
      professionalism.
    `,
  },
);
